import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {Row, Col as Column} from "../Layout";
import Image from "../Image";
import NTMButton from "../Buttons/NTMButton";

import { alertIcon, closeIcon_over, closeIcon } from 'img/icons'
import styles from './_alert.module.scss'


export default class Alert extends Component {

	state = {
		display:"block"
	};

	render() {

		let {title, onClose, onSolve} = this.props;

		return (
				<Column className={classNames(styles.alert, styles.agrismart)} style={{display: this.state.display}}>
					<Row className={styles.titleRow}>
						<div><Image src={alertIcon}/></div>
						<div className={styles.title}>{title}</div>
						{onClose && <div className={styles.close}>
							<Image
								src={closeIcon}
								hover={closeIcon_over}
								onClick={() => {
									this.setState({display: "none"});
									onClose();
								}}
							/>
						</div>}
					</Row>
					{
						onSolve &&
						<Row>
							<NTMButton primary onClick={onSolve}><i className="fa fa-check" aria-hidden="true"></i> Risolvi</NTMButton>
						</Row>
					}
				</Column>
		);
	}
}

Alert.propTypes = {
	id:PropTypes.number,
	title: PropTypes.string.isRequired,
	onClose: PropTypes.func
};
